export const UPDATE_ALL_PRODUCTS = "UPDATE_ALL_PRODUCTS";
export const UPDATE_USER_WALLET = "UPDATE_USER_WALLET";
